import { useContext } from 'react';

import { LayoutContext } from './index';

export function useLayout() {
  return useContext(LayoutContext);
}
